import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    const t = localStorage.getItem("ks_token");
    if (!t) { setChecked(true); return; }
    (async () => {
      try {
        const { data } = await api.get("/auth/me");
        setUser(data);
      } catch (_) {
        localStorage.removeItem("ks_token");
        setUser(null);
      } finally {
        setChecked(true);
      }
    })();
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (data?.token) localStorage.setItem("ks_token", data.token);
    setUser(data.user);
    return data;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (_) {}
    localStorage.removeItem("ks_token");
    setUser(null);
  };

  return (
    <AuthCtx.Provider value={{ user, checked, login, logout }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
